import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { motion } from "framer-motion";
import pic1 from "../../../assets/images/BPO group.jpg";
import pic2 from "../../../assets/images/bpo staff (2).jpg";
import pic3 from "../../../assets/images/bpo staff.jpg";
import { useNavigate } from "react-router-dom";

const BPO = () => {
  const navigate = useNavigate();
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  return (
    <div className="text-gray-800" style={{ marginTop: "80px" }}>
      <motion.header
        className="bg-blue-900 text-white py-16 text-center shadow-lg rounded-lg"
        initial={{ opacity: 0, y: -50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >
        <div className="bg-gradient-to-r from-blue-50 to-indigo-100 py-20">
          <div className="container mx-auto px-4">
            <div className="max-w-4xl mx-auto text-center">
              <h1 className="text-4xl md:text-5xl font-bold mb-6">
                <span className="text-white">
                  🌟 Unlock Your Business's Full Potential with{" "}
                </span>
                <span className="text-blue-600">Our BPO Solutions</span>
              </h1>
              <p className="text-white mb-8">
                Imagine running a thriving business with a steady stream of new
                clients. Our comprehensive BPO services are designed to help you
                achieve exactly that—delivering efficiency, growth, and customer
                satisfaction.
              </p>
              <button
                onClick={() => navigate("/bookmeeting")}
                style={{ color: "black" }}
                className="mt-4 bg-white text-blue-700 px-6 py-3 font-bold rounded-full hover:bg-blue-100 transition"
              >
                Meet Us
              </button>
            </div>
          </div>
        </div>
      </motion.header>

      {/* BPO Experience */}
      <section className="bg-gray-100 py-16 px-6" data-aos="fade-up">
        <div
          className="max-w-6xl mx-auto flex flex-col md:flex-row items-center"
          style={{ gap: "5rem" }}
        >
          {/* Left Column - Image */}
          <div className="w-full md:w-1/2">
            <img
              src={pic1} // Replace with your actual image path
              alt="BPO Services"
              className="rounded-lg shadow-lg w-full h-auto object-cover"
            />
          </div>

          {/* Right Column - Content */}
          <div className="w-full md:w-1/2">
            <h2 className="text-3xl font-bold text-blue-900">
              📈 Our Distinctive BPO Experience
            </h2>
            <p className="text-lg text-gray-700 mt-4">
              Picture your operations running seamlessly with a dedicated team
              handling all your BPO needs. At Right On Time Services, we provide
              end-to-end BPO call center services, including:
            </p>
            <ul className="mt-6 space-y-3 text-lg">
              <li className="flex items-start">
                <span className="mr-2">✅</span>
                <span>24/7 Customer Support</span>
              </li>
              <li className="flex items-start">
                <span className="mr-2">✅</span>
                <span>Inbound & Outbound Sales</span>
              </li>
              <li className="flex items-start">
                <span className="mr-2">✅</span>
                <span>Appointment Scheduling</span>
              </li>
              <li className="flex items-start">
                <span className="mr-2">✅</span>
                <span>Data Processing & Verification</span>
              </li>
            </ul>
            <p className="mt-4 text-gray-700">
              Our cutting-edge technology and robust data security policies
              ensure top-notch customer experiences and safeguard sensitive
              information. We specialize in providing industry-specific
              solutions, understanding the unique demands of sectors like
              healthcare, telecommunications, and FMCG.
            </p>
            <p className="mt-4 text-gray-700">
              Our approach streamlines your operations, boosts growth, and
              delivers a customer experience that sets you apart.
            </p>
            <p className="mt-4 font-bold text-gray-700">
              Partner with us today—see how our BPO services can drive your
              business forward.
            </p>
          </div>
        </div>
      </section>

      {/* Services Overview */}
      <section className="py-16 px-6 mb-6" data-aos="fade-up">
        <div className="max-w-6xl mx-auto text-center">
          <h2 className="text-3xl font-bold text-gray-900">
            💼 Comprehensive Service Suite
          </h2>
          <p className="text-lg text-gray-700 mt-4">
            Delivering excellence at every customer touchpoint.
          </p>
          <p className="text-lg text-gray-700" style={{ marginBottom: "20px" }}>
            Our communication solutions are designed to make customers feel
            heard, valued, and supported. We offer:
          </p>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-8">
            {[
              {
                title: "Inbound & Outbound Call Handling",
                description:
                  "Responsive. Reliable. Remarkable. Our experienced representatives handle inquiries, technical issues, and customer concerns efficiently.",
              },
              {
                title: "Email & Chat Support",
                description:
                  "Expanding your reach, one call at a time. From appointment scheduling and surveys to lead generation.",
              },
              {
                title: "SMS Support",
                description:
                  "Always available, always accurate. We provide 24/7 email and chat support for prompt responses.",
              },
              {
                title: "Technical Support",
                description:
                  "Engage instantly, communicate effortlessly. Real-time customer communication for marketing updates and support.",
              },
              {
                title: "Order Processing",
                description:
                  "Engage instantly, communicate effortlessly. Real-time customer communication for marketing updates and support.",
              },
              {
                title: "Market Research Services",
                description:
                  "Engage instantly, communicate effortlessly. Real-time customer communication for marketing updates and support.",
              },
            ].map((service, index) => (
              <motion.div
                key={index}
                className="bg-white p-6 rounded-lg shadow-lg hover:shadow-lg transition"
                whileHover={{ scale: 1.05 }}
                transition={{ type: "spring", stiffness: 300 }}
              >
                <h3 className="text-xl font-bold text-blue-900">
                  {service.title}
                </h3>
                {/* <p className="text-gray-600 mt-2">{service.description}</p> */}
              </motion.div>
            ))}
          </div>
          <p className="text-lg text-gray-700" style={{ marginTop: "30px" }}>
            Each service is tailored to your business’s unique needs, backed by
            our experienced team committed to delivering outstanding customer
            service.
          </p>
        </div>
      </section>

      {/* Industries We Serve */}
      <section className="bg-gray-200 py-16 px-6" data-aos="fade-up">
        <div className="max-w-6xl mx-auto text-center">
          <h2 className="text-3xl font-bold text-gray-900">
            🌟 Our Exceptional Services—Tailored Just for You
          </h2>
          <p
            className="text-lg text-gray-700 mt-4"
            style={{ marginBottom: "20px" }}
          >
            Our tailored BPO solutions support diverse industries:
          </p>
          <div className="grid grid-cols-2 md:grid-cols-3 gap-4 mt-6">
            {[
              {
                title: "Inbound Calls",
                bold: "Responsive. Reliable. Remarkable.",
                description:
                  "Our experienced representatives handle inquiries, technical issues, and complex customer concerns efficiently, ensuring a warm, engaging customer experience.",
              },
              {
                title: "Outbound Calls",
                bold: "Expanding your reach, one call at a time.",
                description:
                  "From appointment scheduling and customer surveys to collections and lead generation, our outbound call services are designed for business growth and customer engagement.",
              },
              {
                title: "Email & Chat Support",
                bold: "Always available, always accurate.",
                description:
                  "We provide 24/7 email and chat support, ensuring prompt and precise responses to customer inquiries, regardless of the channel.",
              },
              {
                title: "SMS Support",
                bold: "Engage instantly, communicate effortlessly.",
                description:
                  "Our SMS support offers real-time, reliable customer communication for everything from marketing updates to customer support queries.",
              },
            ].map((item, index) => (
              <motion.div
                key={index}
                className="bg-white p-6 rounded-lg shadow-lg hover:shadow-lg transition"
                whileHover={{ scale: 1.05 }}
                transition={{ type: "spring", stiffness: 300 }}
              >
                <h3 className="text-xl font-bold text-blue-900">
                  {item.title}
                </h3>

                <p
                  className="text-gray-600 mt-2"
                  style={{ fontWeight: "bold" }}
                >
                  {item.bold}
                </p>
                <p className="text-gray-600 mt-2">{item.description}</p>
                <p
                  className="text-gray-600 mt-2"
                  style={{ fontWeight: "bold" }}
                >
                  Read More
                </p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      <motion.div
        className="p-6 bg-white rounded-lg transition duration-300"
        data-aos="fade-up"
      >
        <section className="bg-white py-16 px-6 md:px-20">
          <div className="max-w-5xl mx-auto text-center">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-6">
              🏥 Industries We Serve
            </h2>
            <p className="text-gray-600 mb-12">
              Our tailored BPO solutions support diverse industries:
            </p>

            <div className="grid md:grid-cols-3 mt-4 gap-6 text-left">
              <div className="bg-gray-50 p-6 rounded-2xl shadow hover:shadow-md transition">
                <h3 className="text-lg font-semibold text-blue-700 mb-2">
                  Healthcare
                </h3>
                <p className="text-sm text-gray-700">
                  Medical Billing, Credentialing, Virtual Assistance
                </p>
              </div>

              <div className="bg-gray-50 p-6 rounded-2xl shadow hover:shadow-md transition">
                <h3 className="text-lg font-semibold text-purple-700 mb-2">
                  Telecommunications
                </h3>
              </div>

              <div className="bg-gray-50 p-6 rounded-2xl shadow hover:shadow-md transition">
                <h3 className="text-lg font-semibold text-green-700 mb-2">
                  FMCG
                </h3>
              </div>

              <div className="bg-gray-50 p-6 rounded-2xl shadow hover:shadow-md transition">
                <h3 className="text-lg font-semibold text-pink-700 mb-2">
                  Market Research
                </h3>
              </div>

              <div className="bg-gray-50 p-6 rounded-2xl shadow hover:shadow-md transition">
                <h3 className="text-lg font-semibold text-yellow-700 mb-2">
                  E-commerce & Retail
                </h3>
              </div>

              <div className="bg-gray-50 p-6 rounded-2xl shadow hover:shadow-md transition">
                <h3 className="text-lg font-semibold text-red-700 mb-2">
                  Financial Services
                </h3>
              </div>
            </div>
            <p className="text-gray-600 mt-4">
              We streamline operations, improve efficiency, and help clients
              achieve business goals with customized solutions.
            </p>
          </div>
        </section>
      </motion.div>
      {/* Why Choose Us? */}
      <motion.div
        className="p-6 bg-white rounded-lg transition duration-300"
        data-aos="fade-up"
      >
        <section className="py-16">
          <h2 className="text-3xl font-bold text-blue-900 text-center lg:text-left">
            ✅ Why Choose Our BPO Services?
          </h2>
          <div className="max-w-6xl mx-auto flex flex-col lg:flex-row gap-12 items-center">
            {/* Left Column - Content */}
            <div className="w-full lg:w-1/2">
              <ul className="mt-8 space-y-4 text-lg">
                <li className="flex items-start">
                  <span className="mr-2">•</span>
                  <span>Experienced & Dedicated Team</span>
                </li>
                <li className="flex items-start">
                  <span className="mr-2">•</span>
                  <span>24/7 Global Support</span>
                </li>
                <li className="flex items-start">
                  <span className="mr-2">•</span>
                  <span>Latest Technology & Tools</span>
                </li>
                <li className="flex items-start">
                  <span className="mr-2">•</span>
                  <span>Tailored, Scalable Solutions</span>
                </li>
                <li className="flex items-start">
                  <span className="mr-2">•</span>
                  <span>Comprehensive Data Security</span>
                </li>
                <li className="flex items-start">
                  <span className="mr-2">•</span>
                  <span>Omnichannel Support</span>
                </li>
                <li className="flex items-start">
                  <span className="mr-2">•</span>
                  <span>Integrated CRM Solutions</span>
                </li>
                <li className="flex items-start">
                  <span className="mr-2">•</span>
                  <span>Real-Time Analytics</span>
                </li>
                <li className="flex items-start">
                  <span className="mr-2">•</span>
                  <span>Industry-Compliant Security Standards</span>
                </li>
              </ul>
            </div>

            {/* Right Column - Image */}
            <div className="w-full lg:w-1/2">
              <img
                src={pic3}
                alt="BPO Services Benefits"
                className="rounded-lg shadow-xl w-full h-auto object-cover"
                style={{ maxHeight: "500px" }}
              />
            </div>
          </div>
        </section>
      </motion.div>

      <motion.div
        className="p-6 bg-white rounded-lg transition duration-300"
        data-aos="fade-up"
      >
        <section className="bg-gray-100  py-16 px-6 md:px-20">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">
              🚀 READY TO START YOUR PROJECT?
            </h2>
            <p className="text-lg text-gray-700 mb-6">
              Let’s build something amazing together.
            </p>

            <div className="bg-white p-8 rounded-2xl shadow-md mb-8">
              <h3 className="text-2xl font-semibold text-blue-700 mb-2">
                📩 Get in Touch With Us
              </h3>
              <p className="text-gray-600 mb-4">
                Consult with Right On Time Services Today!
              </p>
              <p className="text-gray-700 mb-2">
                Looking for reliable BPO call center solutions? Let’s work
                together.
              </p>
              <p className="text-gray-800 font-medium">
                📧{" "}
                <a
                  href="mailto:info@rightontimeservices.com"
                  className="text-blue-600 underline"
                >
                  info@rightontime.biz
                </a>
              </p>
              <p className="text-gray-800 mt-1">
                📍 1st Floor, Al, Al-Rehman Chamber, Fazal e Haq Road, G 7/3
                Blue Area, Islamabad, 44000
              </p>
            </div>
          </div>
        </section>
      </motion.div>
      {/* Contact & Form Section */}
      <motion.div
        className="p-6 bg-white rounded-lg transition duration-300"
        data-aos="fade-up"
      >
        {/* <section className="py-16 px-6 bg-white" data-aos="fade-up">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-3xl font-bold text-gray-900">
              📝 Get Started Form
            </h2>
            <p
              className="text-lg text-gray-700 mt-4"
              style={{ marginBottom: "12px" }}
            >
              Please provide your details below so we can get started on
              delivering the best BPO solutions for your business.
            </p>
            <form className="mt-8 bg-gray-100 p-6 rounded-lg shadow-lg">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label className="text-gray-700 font-semibold">
                    Select Service:
                  </label>
                  <select
                    className="w-full p-3 mt-2 rounded border"
                    style={{ padding: "6px" }}
                  >
                    <option>BPO</option>
                    <option>Healthcare</option>
                    <option>Digital Marketing</option>
                    <option>Software Development</option>
                    <option>Other</option>
                  </select>
                </div>
                <div>
                  <label className="text-gray-700 font-semibold">
                    Full Name:
                  </label>
                  <input
                    type="text"
                    style={{ padding: "6px" }}
                    className="w-full p-3 mt-2 rounded border"
                    placeholder="Your Name"
                  />
                </div>
                <div>
                  <label className="text-gray-700 font-semibold">
                    Email Address:
                  </label>
                  <input
                    type="email"
                    style={{ padding: "6px" }}
                    className="w-full p-3 mt-2 rounded border"
                    placeholder="Your Email"
                  />
                </div>
                <div>
                  <label className="text-gray-700 font-semibold">
                    Phone Number:
                  </label>
                  <input
                    type="text"
                    style={{ padding: "6px" }}
                    className="w-full p-3 mt-2 rounded border"
                    placeholder="+92 - - - - - -"
                  />
                </div>
                <div>
                  <label className="text-gray-700 font-semibold">
                    Subject:
                  </label>
                  <input
                    type="text"
                    style={{ padding: "6px" }}
                    className="w-full p-3 mt-2 rounded border"
                    placeholder="Your Subject"
                  />
                </div>
              </div>

              <div className="mt-4">
                <label className="text-gray-700 font-semibold">
                  Project Description:
                </label>
                <textarea
                  style={{ padding: "6px" }}
                  className="w-full p-3 mt-2 rounded border"
                  rows="4"
                ></textarea>
              </div>
              <button
                className="w-full mt-6 bg-blue-700 py-3 font-bold rounded-full hover:bg-blue-900 transition"
                style={{ color: "white" }}
              >
                Submit Request
              </button>
            </form>
          </div>
        </section> */}
      </motion.div>
      <motion.div
        className="p-6 bg-white rounded-lg transition duration-300"
        data-aos="fade-up"
      >
        <section className="bg-gray-100  py-16 px-6 md:px-20">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">
              💬 Consult With Confidence — Start Growing Today!
            </h2>
            <p className="text-lg text-gray-700 mb-6">
              Your business success is just one meeting away.
            </p>
          </div>
        </section>
      </motion.div>
    </div>
  );
};

export default BPO;
